import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table from "../../../core/pagination/datatable";
import { API_BASE_URL, API_NOTIFY_URL } from "../Config/Config";
import { Button, Popover, Spin } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { CopyOutlined } from "@ant-design/icons";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";

const MobilreUsers = () => {
  const [mobileUserData, setMobileUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingOrg, setLoadingOrg] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedSuperId, setSelectedSuperId] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const [NotifytModalData, setNotifyModalData] = useState({
    OrgName: "",
    PrimaryEmailAddr: "",
    PrimaryMobile: "",
    Subject: "",
    Message: "",
  });

  const columns = [
    {
      title: "Super Id",
      dataIndex: "SuperId",
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => (a?.SuperId || 0) - (b?.SuperId || 0),
    },
    {
      title: "Client",
      dataIndex: "Client",
    
      render: (_, record) => {
        const value = record?.Client;
    
        if (!value) return "-";
    
        const truncated =
          value.length > 45 ? value.substring(0, 45) + "..." : value;
    
        return <span title={value}>{truncated}</span>;
      },
    
      sorter: (a, b) => (a?.Client || "").localeCompare(b?.Client || ""),
    },

    {
      title: "User Name",
      dataIndex: "UserName",
      render: (text) => {
        if (!text) return "-";

        return (
          <span title={text}>
            {text.length > 15 ? text.substring(0, 15) + "..." : text}
          </span>
        );
      },
      sorter: (a, b) => (a?.UserName || "").localeCompare(b?.UserName || ""),
    },
    {
      title: "Device Id",
      dataIndex: "DeviceId",
      align: "center",
      render: (text) => {
        if (!text) return "-";

        const content = (
          <div
            style={{
              maxWidth: 350,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: 8,
            }}
          >
            <div style={{ wordBreak: "break-word" }}>{text}</div>

            <Button
              size="small"
              icon={<CopyOutlined />}
              onClick={() => navigator.clipboard.writeText(text)}
            >
              Copy
            </Button>
          </div>
        );

        return (
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <Popover
              content={content}
              trigger={["hover", "click"]}
              placement="top"
            >
              <span style={{ cursor: "pointer" }}>
                <i className="fa-solid fa-mobile-screen"></i>
              </span>
            </Popover>
          </div>
        );
      },
    },
    {
      title: "Login Badge",
      dataIndex: "LoginBadge",
      render: (text) => {
        if (!text) return "-";
        return (
          <span title={text}>
            {text?.length > 20 ? text.substring(0, 20) + "..." : text}
          </span>
        );
      },
    },

    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2 p-2 d-flex align-items-center border rounded"
            data-bs-toggle="modal"
            data-bs-target="#Notification"
            onClick={() => fetchCompanyDetails(record)}
          >
            <i className="ti ti-bell" />
          </Link>
        </div>
      ),
    },
  ];

  const fetchCompanyDetails = (record) => {
    console.log(record, "record");

    let finalMessage = "";

    // CASE 1: Client Inactive
    if (!record.IsActive) {
      finalMessage = `
      Hi, ${record.Client}
  
      We noticed that your Device is currently *inactive*.
      Please contact our support team to reactivate your services 
      and resume normal operations.
  
       Device Details:
      Model: ${record.DeviceName}
      Serial No: ${record.SerialNo}
      Loginbadge:${record.LoginBadge}
      DeviceId: ${record.DeviceId}
  
      Warm regards,
      PerennialCode Support Team
  
      Contact Us:
      Phone: 8297230010
      Email: support@perennialcode.in
      `;
    }
    // CASE 2: Client Active but Device Offline
    else if (record.IsActive) {
      finalMessage = `
      Hi, ${record.Client}
  
      Your device appears to be *offline*, and attendance data 
      has not been received for the past few days.
  
      Please check the following:
      • Power supply to the device
      • Internet/network connection
      • Device wiring and connectivity
  
      Device Details:
      Model: ${record.DeviceName}
      Serial No: ${record.SerialNo}
      Loginbadge:${record.LoginBadge}
      DeviceId: ${record.DeviceId}
  
      If the issue persists, kindly contact our support team.
  
      Warm regards,
      PerennialCode Support Team
  
      Contact Us:
      Phone: 8297230010
      Email: support@perennialcode.in
      `;
    }

    setNotifyModalData({
      OrgName: record.Client || "",
      PrimaryEmailAddr: record.EmailId || "",
      PrimaryMobile: record.PrimaryMobile || "",
      Subject: "Important Notification From Our Team",
      Message: finalMessage,
    });
  };

  const sendWhatsAppNotification = async () => {
    if (!NotifytModalData.PrimaryMobile || !NotifytModalData.Message) {
      alert("Contact number and message are required!");
      return;
    }

    try {
      const payload = {
        number: NotifytModalData.PrimaryMobile,
        client: NotifytModalData.OrgName,
        subject: NotifytModalData.Subject,
        message: NotifytModalData.Message,
      };

      console.log("Sending JSON:", payload); // Debugging

      const res = await axios.post(
        `${API_NOTIFY_URL}pcode/sendWhatsAppmessageHealthcheck`,
        payload
      );

      if (res.data.success) {
        alert("WhatsApp message sent successfully!");
      } else {
        alert("Failed to send message!");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
  };

  const handleChange1 = (e) => {
    setNotifyModalData({
      ...NotifytModalData,
      [e.target.name]: e.target.value,
    });
  };

  // Fetch Mobile Users List
  const getMobileUsersData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/getmobileusers`);
      const data = response.data?.ResultData || [];
      setMobileUserData(data);
    } catch (error) {
      console.error("Error fetching mobile users:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Organizations (SuperId dropdown)
  const fetchOrganizations = async () => {
    setLoadingOrg(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/getorganizationtype`
      );
      const data = response.data?.ResultData || [];
      const options = data.map((org) => ({
        value: org.SuperId,
        label: `${org.OrgName}`,
      }));
      setOrganizations(options);
    } catch (error) {
      console.error("Error fetching organizations:", error);
    } finally {
      setLoadingOrg(false);
    }
  };

  // Fetch Users by SuperId
  const fetchUsersBySuperId = async (superId) => {
    if (!superId) {
      setUsers([]);
      return;
    }
    setLoadingUsers(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/getuserbySuperid?SuperId=${superId}`
      );
      const data = response.data?.ResultData || [];
      const userOptions = data.map((user) => ({
        value: user.RegId,
        label: `${user.UserName}`,
        badge: user.Badge,
      }));
      setUsers(userOptions);
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  // Handle SuperId Change
  const handleSuperIdChange = (selectedOption) => {
    setSelectedSuperId(selectedOption);
    setSelectedUser(null); // Reset employee
    fetchUsersBySuperId(selectedOption?.value);
  };

  // Handle Employee Change
  const handleUserChange = (selectedOption) => {
    setSelectedUser(selectedOption);
  };

  // Handle Add Mobile User
  const handleAddMobileUser = async () => {
    setLoading(true);
    if (!selectedSuperId || !selectedUser) {
      Swal.fire(
        "Validation",
        "Please select both Organization and Employee",
        "warning"
      );
      return;
    }

    const payload = {
      SuperId: selectedSuperId.value.toString(),
      RegId: selectedUser.value.toString(),
      Badge: selectedUser.badge,
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/addmobileusers`,
        payload
      );

      if (response.data.Status === true) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Mobile user added successfully!",
          timer: 2000,
          showConfirmButton: true,
          confirmButtonText: "OK",
        });
        document.querySelector("#add_plans .btn-close")?.click();
        setSelectedSuperId(null);
        setSelectedUser(null);
        setUsers([]);
        getMobileUsersData();
      } else {
        throw new Error("Failed to add user");
      }
    } catch (error) {
      console.error("Error adding mobile user:", error);
      Swal.fire(
        "Error",
        error.response?.data?.ResultMessage || "Failed to add mobile user",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getMobileUsersData();
    fetchOrganizations();
  }, []);


  
  const handleRefresh = () => {
    window.location.reload();
  };
  return (
    <>
      <style>
        {`
                .custom-switch.ant-switch-checked {
                    background-color: #dc2626 !important;
                }
                .custom-switch.ant-switch {
                    background-color: #16a34a !important;
                }
                `}
      </style>

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Mobile Users</h4>
                <h6>Manage your Users</h6>
              </div>
            </div>
            <ul className="table-top-head">
            <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add_plans"
              >
                <i className="ti ti-circle-plus me-1"></i>Add
              </Link>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <h5 className="p-2">Mobile Users List</h5>
              <div className="search-set"></div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-5">
                    <Spin size="large" />
                    <p>Loading users...</p>
                  </div>
                ) : (
                  <Table columns={columns} dataSource={mobileUserData} />
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>

      {/* Add Mobile User Modal */}
      <div className="modal fade" id="add_plans">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Mobile User</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Organization *</label>
                  <Select
                    value={selectedSuperId}
                    onChange={handleSuperIdChange}
                    options={organizations}
                    isLoading={loadingOrg}
                    placeholder="Select Organization"
                    classNamePrefix="react-select"
                    isClearable
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Employee *</label>
                  <Select
                    value={selectedUser}
                    onChange={handleUserChange}
                    options={users}
                    isLoading={loadingUsers}
                    isDisabled={!selectedSuperId}
                    placeholder={
                      selectedSuperId
                        ? "Select Employee"
                        : "First select Organization"
                    }
                    classNamePrefix="react-select"
                    isClearable
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Selected Badge</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedUser?.badge || ""}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleAddMobileUser}
              >
                Add User
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="Notification">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="text-gray-9 fw-medium">
                Send Notification To Mobile User
              </h3>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className=" fw-medium">Client</label>
                    <input
                      type="text"
                      className="form-control"
                      name="OrgName"
                      value={NotifytModalData.OrgName}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className=" fw-medium">Subject</label>
                    <input
                      type="text"
                      className="form-control"
                      name="Subject"
                      value={NotifytModalData.Subject}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="fw-medium">Email To</label>
                    <input
                      type="email"
                      className="form-control"
                      name="PrimaryEmailAddr"
                      value={NotifytModalData.PrimaryEmailAddr}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="fw-medium">Contact</label>
                    <input
                      type="text"
                      className="form-control"
                      name="PrimaryMobile"
                      value={NotifytModalData.PrimaryMobile}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="fw-medium">Notify Message Content</label>
                    <textarea
                      className="form-control"
                      rows="5"
                      name="Message"
                      value={NotifytModalData.Message}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="text-center">
                  <button
                    className="btn btn-success text-white"
                    onClick={sendWhatsAppNotification}
                  >
                    Notify
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobilreUsers;
